<template>
    <div class="coin-icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 79.46 79.1" style="enable-background:new 0 0 79.46 79.1;" xml:space="preserve">

            <path class="st0" d="M62.05,16.44c7.76,5.95,12.76,15.32,12.76,25.86c0,17.99-14.58,32.57-32.57,32.57
                c-10.49,0-19.83-4.96-25.78-12.67"/>
            <circle class="st0" cx="36.87" cy="37.11" r="32.57"/>
            <g>
                <path d="M35.98,57.11c-0.3,0-0.56-0.11-0.77-0.32c-0.21-0.21-0.32-0.47-0.32-0.77v-3.18c-2.24-0.21-4.14-0.75-5.68-1.61
                    s-2.71-1.91-3.5-3.14c-0.79-1.23-1.21-2.51-1.27-3.84c0-0.27,0.1-0.5,0.3-0.68c0.2-0.18,0.43-0.27,0.7-0.27h4.05
                    c0.36,0,0.65,0.08,0.86,0.25c0.21,0.17,0.38,0.37,0.5,0.61c0.21,0.58,0.57,1.14,1.07,1.71c0.5,0.56,1.2,1.02,2.11,1.39
                    c0.91,0.36,2.05,0.55,3.41,0.55c2.18,0,3.8-0.36,4.87-1.09c1.06-0.73,1.59-1.71,1.59-2.96c0-0.88-0.28-1.58-0.84-2.11
                    c-0.56-0.53-1.45-1.02-2.66-1.45c-1.21-0.44-2.8-0.9-4.77-1.39c-2.24-0.55-4.14-1.2-5.68-1.98c-1.55-0.77-2.71-1.75-3.48-2.93
                    c-0.77-1.18-1.16-2.68-1.16-4.5c0-2.33,0.85-4.32,2.55-5.96c1.7-1.64,4.05-2.64,7.05-3v-3.14c0-0.3,0.11-0.56,0.32-0.77
                    c0.21-0.21,0.47-0.32,0.77-0.32h2.77c0.3,0,0.56,0.11,0.77,0.32c0.21,0.21,0.32,0.47,0.32,0.77v3.23c2.06,0.3,3.79,0.91,5.18,1.82
                    c1.39,0.91,2.46,1.95,3.18,3.11c0.73,1.17,1.11,2.3,1.14,3.39c0,0.24-0.08,0.46-0.25,0.66c-0.17,0.2-0.4,0.3-0.7,0.3h-4.23
                    c-0.27,0-0.53-0.06-0.77-0.18c-0.24-0.12-0.44-0.35-0.59-0.68c-0.15-0.94-0.73-1.74-1.73-2.41c-1-0.67-2.3-1-3.91-1
                    c-1.64,0-2.95,0.3-3.93,0.91c-0.99,0.61-1.48,1.55-1.48,2.82c0,0.85,0.24,1.55,0.73,2.11c0.48,0.56,1.28,1.05,2.39,1.48
                    c1.11,0.42,2.58,0.88,4.43,1.36c2.58,0.58,4.68,1.24,6.3,2c1.62,0.76,2.82,1.72,3.59,2.89c0.77,1.17,1.16,2.64,1.16,4.43
                    c0,1.76-0.43,3.3-1.3,4.62s-2.08,2.38-3.66,3.18c-1.58,0.8-3.43,1.33-5.55,1.57v3.14c0,0.3-0.11,0.56-0.32,0.77
                    c-0.21,0.21-0.47,0.32-0.77,0.32H35.98z"/>
            </g>
        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log('Colors: ', this.colors)
    }       
}
</script>

<style lang="scss" scoped>
    .st0{fill:#FFFFFF;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}
</style>
